import { cn } from '../../lib/utils';

/** Centered card widths for {@link Modal} (`full` is handled separately). */
const MODAL_SIZE: Record<'sm' | 'md' | 'lg' | 'xl', string> = {
  sm: 'sm:max-w-sm',
  md: 'sm:max-w-lg',
  lg: 'sm:max-w-2xl',
  xl: 'sm:max-w-4xl',
};

/**
 * Cover the current window: no dim, no card chrome, no close control. Overrides
 * DialogContent's centered `top/left/translate/max-w` defaults.
 */
const MODAL_FULL_CLASS =
  'inset-0 top-0 left-0 h-full w-full max-h-none max-w-none translate-x-0 translate-y-0 overflow-hidden rounded-none border-0 bg-transparent p-0 shadow-none gap-0 sm:max-w-none data-starting-style:scale-100 data-ending-style:scale-100';

export type ModalSize = 'sm' | 'md' | 'lg' | 'xl' | 'full';

/** Shell classes + chrome flags derived from {@link ModalSize}. */
export function modalChrome(size: ModalSize | undefined): {
  cover: boolean;
  contentClass: string;
} {
  if (size === 'full') {
    return { cover: true, contentClass: MODAL_FULL_CLASS };
  }
  return {
    cover: false,
    contentClass: cn('max-h-[85vh] overflow-hidden', MODAL_SIZE[size ?? 'md']),
  };
}
